import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthorizeService } from '@shared/services/authorize.service';
import { ConfigService } from '@shared/services/config.service';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class JwtInterceptor implements HttpInterceptor {
  private readonly authorize = inject(AuthorizeService);
  private readonly configService = inject(ConfigService);

  public urlPropertyNames = ['clubHubApiUrl', 'lenderHubApiUrl', 'identityServerUrl'];

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.isOAuthRequest(request.url)) {
      return next.handle(request);
    }
    return this.authorize.getAccessToken().pipe(mergeMap(token => this.processRequestWithToken(token, request, next)));
  }

  private isOAuthRequest(url: string): boolean {
    // Ignore authLib requests
    return url.includes('/token') || url.includes('/connect') || url.includes('/.well-known');
  }

  // Checks if there is an access_token available in the authorize service
  // and adds it to the request in case it's targeted at the same origin as the
  // single page application.
  private processRequestWithToken(token: string | null, request: HttpRequest<unknown>, next: HttpHandler) {
    if (!!token && this.isSameOriginUrl(request)) {
      request = request.clone({
        setHeaders: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          Authorization: `Bearer ${token}`,
        },
      });
    }

    return next.handle(request);
  }

  private isSameOriginUrl(request: any) {
    return this.urlPropertyNames.some(property => this.checkUrlAgainstProperty(property, request.url));
  }

  private checkUrlAgainstProperty(property: string, url: string): boolean {
    return (this.configService.config?.hasOwnProperty(property) && url.startsWith(`${(this.configService.config as any)[property]}/`)) ?? false;
  }
}
